const _excluded = ["data"];
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import styled from "styled-components";
import Link from "@nib-components/link";
import { copyFontSizeSmall } from "@nib-components/theme";
import { Inline, Container, breakpoint, mr } from "@nib/layout";
const RibbonWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  color: inherit;
`;
const RibbonLinks = styled.div`
  ${mr(5)};

  ${breakpoint("xl", "xxl")`
    ${mr(3)};
  `}
`;
export const RibbonLink = styled(Link)`
  &&& {
    color: inherit;
    font-size: ${copyFontSizeSmall};
  }
`;
const Ribbon = _ref => {
  let {
      data
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (!data || data.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(RibbonWrapper, otherProps, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(RibbonLinks, null, /*#__PURE__*/React.createElement(Inline, {
    space: 3,
    align: "right"
  }, data.map((link, i) => /*#__PURE__*/React.createElement(RibbonLink, {
    id: `${link.id}-desktop`,
    key: `item-${i}-${link.id}-desktop`,
    href: link.url,
    title: link.title
  }, link.title))))));
};
export default Ribbon;